<template>
<div>
  <v-subheader class='my-0 pl-0 overline' >
    Set a default invoice description on new appointments
  </v-subheader>

  <v-select dense chips small-chips clearable persistent-hint
    v-model='selected'
    label='Choose a template'
    :hint='hint'
    :items='items' />

  <v-text-field autofocus
    v-model='customText'
    v-if='selected==="custom"'
    label='Enter your custom description here' />

  <p class='caption mt-2' >
    <v-icon small >mdi-information</v-icon>
    AppointmentGuru will automatically set this invoice description when creating new appointments - you can always change it later
  </p>
  <!-- <div class='caption grey lighten-4' v-text='text' /> -->
</div>
</template>
<script>
const messageMap = {
  treatedAtSpace: 'Treated by: {{appointment.practitioner_name}} {% if appointment.practitioner and appointment.practitioner.profile.registration_number %}({{appointment.practitioner.profile.registration_number}}){% endif %}{% if appointment.space and appointment.space.title %} at {{appointment.space.title}}{% endif %}',
  treatedAtAddress: 'Treated by: {{appointment.practitioner_name}} {% if appointment.practitioner and appointment.practitioner.profile.registration_number %}({{appointment.practitioner.profile.registration_number}}){% endif %}{% if appointment.address and appointment.address.name %} at {{appointment.address.name}}{% endif %}'
}
const messageExampleMap = {
  treatedAtSpace: 'For example: Treated by Jane Smith (BK123456) at Eatwell Dieticians',
  treatedAtAddress: 'For example: Treated by Jane Smith (BK123456) at 15 Oxford street',
}
export default {
  name: 'InvoiceDescriptionPicker',
  props: {
    value: { type: String }
  },
  watch: {
    selected () {
      if (this.selected in messageMap) {
        this.text = messageMap[this.selected]
      }
      if (!this.selected) { this.text = null }
    },
    text () {
      this.$emit('input', this.text)
    },
    customText () { this.text = this.customText },
    value: {
      immediate: true,
      handler () {
        this.items.forEach((item) => {
          if (messageMap[item.value] === this.value) {
            this.selected = item.value
          }
        })
        if (!this.selected && this.value) {
          this.selected = 'custom'
          this.customText = this.value
        }
      }
    }
  },
  computed: {
    hint () {
      if (this.selected in messageExampleMap) {
        return messageExampleMap[this.selected]
      }
      if (this.selected === 'custom') {
        return 'Write your own invoice description'
      }
      return null
    }
  },
  data () {
    return {
      text: '',
      customText: '',
      selected: null,
      items: [
        {
          value: 'treatedAtSpace',
          text: 'Treated by {practitioner} ({HPSCA number}) at {space}'
        },
        {
          value: 'treatedAtAddress',
          text: 'Treated by {practitioner} ({HPSCA number}) at {space.address}'
        },
        {
          value: 'custom',
          text: 'Custom'
        }
      ]
    }
  }
}
</script>
